import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { User } from '../../../models/Core/User';

@Component({
  selector: 'app-filtered-users-preview',
  templateUrl: './filtered-users-preview.component.html',
  styleUrls: ['./filtered-users-preview.component.scss'],
})
export class FilteredUsersPreviewComponent implements OnInit, OnDestroy {
  _users: User[];
  currentlySelectedUser: User;
  currentlySelectedIndex;
  private arrowLeftListener: (event) => void;
  private arrowRightListener: (event) => void;

  @Input() set users(users: User[]) {
    this.setUsers(users);
    if (
      (!this.currentlySelectedUser && users.length > 0) ||
      users.map(user => user._id).indexOf(this.currentlySelectedUser._id) < 0
    ) {
      this.currentlySelectedUser = users[0];
      this.currentlySelectedIndex = 0;
    } else if (this.currentlySelectedUser) {
      this.currentlySelectedIndex = this._users
        .map(user => user._id)
        .indexOf(this.currentlySelectedUser._id);
    }
  }

  showPreviousUser() {
    if (this.currentlySelectedIndex > 0) {
      this.currentlySelectedIndex =
        (this.currentlySelectedIndex - 1) % this._users.length;
      this.currentlySelectedUser = this.getUsers()[this.currentlySelectedIndex];
    }
  }

  showNextUser() {
    if (this.currentlySelectedIndex < this._users.length - 1) {
      this.currentlySelectedIndex =
        (this.currentlySelectedIndex + 1) % this._users.length;
      this.currentlySelectedUser = this.getUsers()[this.currentlySelectedIndex];
    }
  }

  setUsers(users: User[]) {
    this._users = users;
  }

  getUsers() {
    return this._users;
  }

  ngOnInit() {
    this.arrowLeftListener = event =>
      event.key === 'ArrowLeft' && this.showPreviousUser();
    this.arrowRightListener = event =>
      event.key === 'ArrowRight' && this.showNextUser();
    window.addEventListener('keydown', this.arrowLeftListener, true);
    window.addEventListener('keydown', this.arrowRightListener, true);
  }

  ngOnDestroy() {
    window.removeEventListener('keydown', this.arrowLeftListener, true);
    window.removeEventListener('keydown', this.arrowRightListener, true);
  }
}
